import { GAMES, teamGameOf } from "@playside/domain/games"

/** Read-only label for `teams.country`. NULL means the team never chose one and behaves as US. */
export function teamCountryLabel(country: "us" | "ca" | null | undefined): string {
  if (country === "ca") return "Canada"
  if (country === "us") return "United States"
  return "Not set (US)"
}

/**
 * Read-only label for a team's game ("What do you play?"). NULL means the team never chose one and
 * reads through its country (Canada is Canadian 12, anything else Football 11).
 */
export function teamGameLabel(
  game: string | null | undefined,
  country: string | null | undefined
): string {
  const label = GAMES[teamGameOf({ game, country })].label
  return game ? label : `Not set (${label})`
}
